<template>
  <div class="activity-wrap">
    <div id="container" class="container">
      <div class="content">
        <div>
        <p class="banner" v-show="this.appointPower">
          <img src="../../assets/images/activity/activity20240913/banner1.jpg" alt=""  @click="goFreeHongkongLevel2()" v-if="this.remain > 0 && !this.received"/>
          <i class="amount" v-show="this.remain > 0 && !this.received">{{ this.total }}</i>
          <img src="../../assets/images/activity/activity20240913/banner2.jpg" alt="" @click="goBuy()" v-if="this.received" />
          <img src="../../assets/images/activity/activity20240913/banner3.jpg" alt="" @click="goBuy()" v-if="this.remain <= 0" />
        </p>
      </div>
        <p>
          <img src="../../assets/images/activity/activity20240913/01_01.png" alt="" />
        </p>

        <p>
          <img src="../../assets/images/activity/activity20240913/01_02.png" alt="" />
        </p>
        <p>
          <img
            v-for="(image, index) in images1"
            :key="index"
            :src="require('../../assets/images/activity/activity20240913/'+image)"
            :alt="'Image ' + (index + 1)"
            v-show="currentImageIndex1 === index"
          />
        </p>

        <p>
          <img src="../../assets/images/activity/activity20240913/01_04.png" alt="" />
        </p>

        <p>
          <img
            v-for="(image, index) in images2"
            :key="index"
            :src="require('../../assets/images/activity/activity20240913/'+image)"
            :alt="'Image ' + (index + 1)"
            v-show="currentImageIndex2 === index"
          />
        </p>
        <p>
          <img src="../../assets/images/activity/activity20240913/01_06.png" alt="" />
        </p>
        <p>
          <img
            v-for="(image, index) in images3"
            :key="index"
            :src="require('../../assets/images/activity/activity20240913/'+image)"
            :alt="'Image ' + (index + 1)"
            v-show="currentImageIndex3 === index"
          />
        </p>
        <p>
          <img src="../../assets/images/activity/activity20240913/01_08.png" alt="" />
        </p>

        <p>
          <!-- <img src="../../assets/images/activity/activity20240913/01_08.png" alt="" /> -->
        </p>
        <p>
          <img
            v-for="(image, index) in images4"
            :key="index"
            :src="require('../../assets/images/activity/activity20240913/'+image)"
            :alt="'Image ' + (index + 1)"
            v-show="currentImageIndex4 === index"
          />
        </p>

        <p>
          <img src="../../assets/images/activity/activity20240913/01_11.png" alt="" />
        </p>
        <p>
          <img src="../../assets/images/activity/activity20240913/01_12.png" alt="" />
        </p>
        <p>
          <img src="../../assets/images/activity/activity20240913/01_13.png" alt="" />
        </p>

        <p class="buyBtn" v-show="!this.past">
          <img src="../../assets/images/activity/activity20240913/01_14-1.png" alt="" @click="goBuy()"/>
        </p>
        <p class="buyBtn" v-show="this.past">
          <img src="../../assets/images/activity/activity20240913/01_14-0.png" alt="" @click="goBuy()"/>
        </p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" src="https://mnews.dzh.com.cn/wap/style/other/js/stat-tj.js"></script>
<script type="text/javascript" src="https://mnews.dzh.com.cn/wap/style/common/js/zepto.min.js"></script>
<script type="text/javascript" src="https://mnews.dzh.com.cn/wap/style/common/js/rem_750_100_min.js"></script>
<script src="js/vue.min.js"></script>
<link type="text/css" media="all" rel="stylesheet" href="https://mnews.dzh.com.cn/wap/style/common/css/base_min.css" />

<script>
export default {
  components: {
  },
  data() {
    return {
      s: this.$route.query.s,
      currentImageIndex1: 0,
      currentImageIndex2: 0,
      currentImageIndex3: 0,
      currentImageIndex4: 0,
      images1: [
                "01_03.png",
                "03_03.png",
                "03_03.png"
              ],
      images2: [
                "01_05.png", 
                "02_05.png",
                "03_05.png"
              ],
      images3: [
                "01_07.png",
                "02_07.png",
                "03_07.png"
              ],
      images4: [
                "01_10.png",
                "02_10.png",
                "03_10.png"
              ],
      remain: 0, //当月剩余量
      received: false, //当月是否赠送 0 未领取 1 已领取
      appointPower: false, //是否有指定权限  0 没有 1 有
      total: 0,
      past: true,
    }
  },
  watch: {
  },
  created() {
    if(!this.s){
      this.s = "";
    };
    this.checkUserPower()
  },
  mounted() {
    this.startImageRotation();
  },
  beforeDestroy() {
    clearInterval(this.rotationInterval);
  },
  methods: {
    startImageRotation() {
        var _this = this;
        _this.rotationInterval = setInterval(function () {
          _this.currentImageIndex1 =
            (_this.currentImageIndex1 + 1) % _this.images1.length;
          _this.currentImageIndex2 =
            (_this.currentImageIndex2 + 1) % _this.images2.length;
          _this.currentImageIndex3 =
            (_this.currentImageIndex3 + 1) % _this.images3.length;
          _this.currentImageIndex4 =
            (_this.currentImageIndex4 + 1) % _this.images4.length;
        }, 800); // 每秒切换一次
      },
    goFreeHongkongLevel2(){
      var param = {
        act: 'hk'
      }
      this.$post("/user/free365Power",param)
        .then(response => {
          if (response.code === 0) {
            this.$global.alert("您已成功领取了PC港股level2月卡，请重启软件查看吧~");
          }else if (response.code === 502){
            this.$global.alert("您已经领取过该福利了，不要重复领取喽~");
          }else if (response.code == 501) {
            this.$global.alert("您暂不符合活动要求哦，请下次再来吧");
          }else if (response.code == 549) {
            this.$global.alert("活动名额已满，请下次再来吧");
          }else {
            this.$global.alert(response.msg)
          }
      })
        .catch(err => {
          this.$global.alert("网络异常，请稍后重试");
        });
    },
    checkUserPower(){
      this.$post("/user/checkFree")
        .then(response => {
          if (response.code === 0) {
            this.remain = response.data.remain;
            if (response.data.received == 1) {
              this.received = true;
            }
            if (response.data.appointPower == 1) {
              this.appointPower = true;
            }
            if (response.data.total) {
              this.total = response.data.total;
            }
            this.past = response.data.past; 
          }else {
            this.$global.alert(response.msg)
          }
      })
        .catch(err => {
          this.$global.alert("网络异常，请稍后重试");
        });
    },
    goBuy(){
      var routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: 2022,month: 12}})
      let {href} = routerDate;
      window.location.href = href + "?s=" + this.s;
    },
  }
};
</script>

<style type="text/css" scoped>
  html {
    font-size: 50px;
    color: #333;
    background-color: #0A1B95;
    min-height: 100vh;
    overflow-x: hidden;
    -webkit-tap-highlight-color: transparent;
    max-width: 1000px;
    margin: 0 auto;
    width: 100%;
  }
body {
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  font-family: Arial, "Microsoft Yahei", "Helvetica Neue", Helvetica, sans-serif;
  font-size: 0.28em;
  line-height: 1;
  color: #333;
  -webkit-text-size-adjust: none;
  min-height: 100vh;
}

a {
  text-decoration: none;
}
.buyBtn {
  position: fixed;
  bottom: 0;
  left: 50%;
  max-width: 1000px;
  background: #f2c28e;
  text-align: center;
  padding: 35px 0;
  width: 100%;
  transform: translateX(-50%);
}

.buyBtn img {
  max-width: 453px;
  max-height: 40px;
}

.container {
  padding-bottom: 1rem;
  background: #0a1b95;
  height: 4950px;
}
.content{
  max-width: 1000px;
  height: 4950px;
  margin:0 auto
}
.banner {
  position: relative;
}
.banner .amount {
  position: absolute;
  color: #553a28;
  width: 100px;
  top: 46%;
  left: 50%;
  margin-left: -100px;
  display: block;
  text-align: center;
  font-size: 32px;
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activity20240913.vue